import styled from '@emotion/styled';

import { ItemCard } from '../../components/ItemCard/ItemCard';
import { PdpDeliveryType } from '../../graphql/select-option_types.2';
import { useItemCardsService } from '../../services/useItemCardsService';
import { OptionType } from '../../types/option-type';

export function ItemCardsContainer({
  disableRemove,
  disabledPrice,
  hiddenCounter,
  disabledCounter,
  disabledShipping,
  allowAnyQuantity,
}: {
  disableRemove?: boolean;
  disabledPrice?: boolean;
  hiddenCounter?: boolean;
  disabledCounter?: boolean;
  disabledShipping?: boolean;
  allowAnyQuantity?: boolean;
}) {
  const service = useItemCardsService({
    allowAnyQuantity,
    disabledCounter,
  });

  return (
    <ItemCardContainer disable_gutter={service.isNoOption}>
      {service.itemCards.map(({ item, optionNames, minCount, maxCount, is_bogo, is_zigzin }) => {
        const { delivery_type, expected_delivery_date, remain_stock, count, price, option_type } = item;

        const itemProps = {
          optionNames,
          price,
          remain_stock,
          expectedDeliveryDate: !disabledShipping ? expected_delivery_date : null,

          count,
          maxCount: service.getMaxCount(item, maxCount),
          minCount: service.getMinCount(item, minCount),

          disabledPrice,
          disableMinCounter: service.disableMinCounter(count),
          disableCounter: service.disableCounter,
          hiddenCounter,

          bogoImageUrl: service.bogoImageUrl,

          is_zigzin,
          isFastShipping: delivery_type === PdpDeliveryType.FAST,
          is_store_zigzin: delivery_type === PdpDeliveryType.VENDOR_FLEX,
          is_additional: option_type === OptionType.ADDITIONAL,
          isOrderQuantityItemType: service.isOrderQuantityItemType,

          over_max_message: service.over_max_message,
          under_min_message: service.orderQuantityToastMessage,
        };
        return (
          <ItemCard
            key={optionNames}
            {...itemProps}
            onChangeItemCount={(v) => service.handleChangeItemCount(item, v)}
            onRemove={disableRemove || service.isNoOption ? undefined : service.handleItemCardRemove(item)}
          />
        );
      })}
    </ItemCardContainer>
  );
}

const ItemCardContainer = styled.div<{ disable_gutter: boolean }>`
  margin: 0 0 8px 0;
  padding-top: ${({ disable_gutter }) => `${disable_gutter ? 0 : 16}px`};
`;
